// This is temporary until the whole contact record is in React, in which case it will have its own boundary
import React from 'react';
import PropTypes from 'prop-types';

import { error } from 'utils/rollbarLogger';
import WidgetHeader from 'components/WidgetHeader/WidgetHeader';

class RemindersErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(e, errorInfo) {
    error('RemindersError', e, errorInfo);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div>
          <WidgetHeader text='Reminders' />
          <div className='reminder-list'>
            We're sorry, something went wrong. If this problem persists, please&nbsp;
            <a href='mailto:enrollmentsupport@finalsite.com'>contact support</a>
            .
          </div>
        </div>
      );
    }

    return children;
  }
}

RemindersErrorBoundary.defaultProps = {
  children: null
};

RemindersErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default RemindersErrorBoundary;
